
import { CompanyManager } from '@/components/admin/CompanyManager';

export const AdminCompaniesTab = () => {
  return (
    <div className="mt-4">
      <CompanyManager />
    </div>
  );
};
